import { Button, ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from "@heroui/react"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import PropTypes from "prop-types"

const AvailabilityModeToggle = ({ handleModeChange, mode }) => (
  <ButtonGroup variant="solid" color="primary">
    <Button>{mode === "standard" ? "Standard Mode" : "Availability Mode"}</Button>

    <Dropdown placement="bottom-end">
      <DropdownTrigger>
        <Button isIconOnly>
          <ChevronDownIcon />
        </Button>
      </DropdownTrigger>

      <DropdownMenu
        disallowEmptySelection
        aria-label="Mode Selector"
        className="max-w-[300px]"
        selectedKeys={new Set([mode])}
        selectionMode="single"
        onSelectionChange={handleModeChange}
      >
        <DropdownItem key="standard" description="View all slot statuses.">
          Standard
        </DropdownItem>
      
        <DropdownItem key="availability" description="Quickly toggle between available and disabled.">
          Availability
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </ButtonGroup>
)

AvailabilityModeToggle.propTypes = {
  handleModeChange: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(["standard", "availability"]).isRequired,
}

export default AvailabilityModeToggle